import { HStack, VStack } from '@ayble-health/dashboard-components';
import React from 'react';
import { Skeleton } from '@chakra-ui/react';
import styled from '@emotion/styled';

const Grid = styled('div')`
  width: 100%;
  display: grid;
  gap: 6px;
  grid-auto-rows: 40px;
  grid-template-columns: 1fr 1fr 1fr;
  min-height: 0;
  overflow: auto;
`;

export const MeetingListSkeleton = () => (
  <VStack height={'160px'} gap={'4px'} w={'100%'}>
    <VStack
      borderColor={'cloud.200'}
      borderWidth={1}
      borderRadius={'8px'}
      flex={1}
      padding={'16px'}
      width={'100%'}
    >
      <HStack alignItems={'center'} alignSelf={'flex-start'} mb={3}>
        <Skeleton rounded={'full'} boxSize={'24px'} />

        <Skeleton ml={'8px'} height={'14px'} rounded={'md'} width={'100px'} />
      </HStack>

      <Grid>
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
        <Skeleton h={'32px'} minH={'32px'} rounded={'2xl'} />
      </Grid>
    </VStack>
  </VStack>
);
